module.exports = __webpack_public_path__ + "static/media/pinkmedium.7b3e03bf.svg";